import React from 'react';
import { SearchIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section id="home" className="relative w-full min-h-[38vh] md:min-h-[60vh] flex items-center justify-center overflow-hidden bg-secondary py-12 md:py-0" data-id="element-145">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: 'url("https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?w=1600&q=80")'
    }} data-id="element-146">
        <div className="absolute inset-0 bg-black/60" data-id="element-147"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-center text-center" data-id="element-148">
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="text-4xl md:text-6xl lg:text-7xl font-bold text-white tracking-tight mb-8" data-id="element-149">
          HELP IS ON THE WAY
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2,
        ease: 'easeOut'
      }} className="w-full max-w-2xl bg-white rounded-[10px] shadow-2xl p-2 flex items-center" data-id="element-150">
          <div className="pl-4 pr-2 text-gray-400" data-id="element-151">
            <SearchIcon className="w-6 h-6" data-id="element-152" />
          </div>
          <input type="text" placeholder="find help near you, enter your zip code or click find me" className="w-full py-4 px-2 text-lg text-gray-900 bg-transparent border-none focus:outline-none focus:ring-0 placeholder-gray-400" data-id="element-153" />
          <button className="hidden sm:block bg-secondary hover:bg-blue-900 text-white font-bold py-3 px-8 rounded-[8px] transition-colors whitespace-nowrap ml-2" data-id="element-154">
            Find Help
          </button>
        </motion.div>
      </div>
    </section>;
}